document.addEventListener('DOMContentLoaded',function (){
  const buttons = document.querySelectorAll(".product-gallery__thumbnail-scroller .product-gallery__thumbnail");
  const Images = document.querySelectorAll(".product-gallery__carousel .product-gallery__media");
  buttons.forEach((item) => {
    item.addEventListener("click", function () {
      let itemId = this.getAttribute("data-media-id");
      Images.forEach((imgid) => {
        let media_ID = imgid.getAttribute("data-media-id");
        if (itemId === media_ID) {
          imgid.style.display = "block";
        } else {
          imgid.style.display = "none";
        }
      });
    });
  });
// p code end


  // -------------------- Add on product js start -------------------- 
  let addonProduct = document.querySelector('.addon-cart');
  if(addonProduct){
    addonProduct.addEventListener('click',function (){
      let addonId = addonProduct.dataset.bundleVariant;
      let formData = {
        'items': [{
          'id': addonId,
        }]
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(response => response.json())
        .then(data)
        .catch(error => console.error('Error:', error));
    })
  }

    // -------------------- product page cart button price update start -------------------- 

    const productCartBtn = document.querySelector('.product-info__block-item .itg-proButton');
    const productQuantityInput = document.querySelector('.product-info__block-item .quantity-selector__input-wrapper input');
    const productQtyBtns = document.querySelector('.product-info__block-item .quantity-selector');
    const productCartBtnPrice = Number(productCartBtn.dataset.price);
    const productCartBtnPriceEl = productCartBtn.querySelector('.itg_priceUpdate');
    
    const updatePrice = () => {
      const totalPrice = Number(productQuantityInput.value) * productCartBtnPrice;
      productCartBtnPriceEl.innerText = totalPrice.toFixed(2);
    };
    
    productQuantityInput.addEventListener('input', updatePrice);
    productQtyBtns.addEventListener('click', (e) => {
      if (e.target.closest('.quantity-selector__button, .icon')) updatePrice();
    }); 
  

   //  Quantity in cart page

   const cartQtyLabel = document.querySelector('.product-info__block-item .cartQtyLabel');

  function reloadElement() {
      setTimeout(() => {
        if(cartQtyLabel){
          fetch(window.location.href)
          .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then(data => {
            const newContent = new DOMParser()
              .parseFromString(data, 'text/html')
              .querySelector('.cartQtyLabel');
            
            if (newContent) {
              cartQtyLabel.innerHTML = newContent.innerHTML;
              console.log(newContent)
              console.log('Updated content:', newContent.innerHTML);
            } else {
              console.warn('No element with class .cartQtyLabel found in fetched content.');
            }
          })
          .catch(error => console.error('Error loading content:', error));
        }
      },1000)
    }

  
  if (productCartBtn) {
    productCartBtn.addEventListener('click',reloadElement);
  }
    document.addEventListener('click', (e) => {
      let proURL = window.location.href;
      let cartProHandleMatch = e.target.closest('.rebuy-cart__flyout-item-info')?.querySelector('.rebuy-cart__flyout-item-product-title')?.href;
      if (e.target.closest('.rebuy-cart__flyout-item-info') && proURL.includes(cartProHandleMatch)) {
        reloadElement();
      }
      if (e.target.closest('.rebuy-cart__flyout-item-remove') && cartQtyLabel && proURL.includes(cartProHandleMatch)) {
        cartQtyLabel.innerHTML = 0;
      }
    });
});

